import StudyItem from './template';
export default StudyItem;
